import React from "react";
import { useSelector } from "react-redux";
import DataDisplay from "../../../../components/dataDisplay/dataDisplay";
import { withToggle } from "../withToggle";

const ReactivatedMembers = ({ qa }) => {
  const {
    reactivatedMembersNumber,
    reactivatedMembersLink,
    reactivatedMembersPercentChange,
    prevReactivatedMembersNumber,
    prevReactivatedMembersLink,
    tooltip
  } = useSelector(
    (state) => state.membershipUnits.membershipUnits.totalNewMembers.reactivatedMembers
  );

  return (
    <>
      <div className="content__el">
        <DataDisplay
          label="Rejoin Members"
          type="number"
          value={reactivatedMembersNumber}
          url={reactivatedMembersLink}
          disableAnimation={qa}
          toolTipContent={tooltip}
          toolTipId="membershipUnitsReactivatedMembers"
          changeProps={{
            changeValue: reactivatedMembersPercentChange,
            toolTip: "Percentage change from previous month",
            showBorder: true
          }}
        />
      </div>
      <PreviousReactivatedMembers
        title="Previous Rejoin Members"
        commonProps={{
          toolTipContent: `Previous ${tooltip}`,
          toolTipId: "membershipUnitsPrevReactivatedMembers"
        }}
        dataPointProps={{
          type: "number",
          value: prevReactivatedMembersNumber,
          url: prevReactivatedMembersLink,
          disableAnimation: qa
        }}
      />
    </>
  );
};

const PreviousReactivatedMembers = withToggle(DataDisplay);

export default ReactivatedMembers;
